import React from 'react';

const CheckmarkIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.79508 16.3749L4.62508 12.2049L3.20508 13.6149L8.79508 19.2049L20.7951 7.20492L19.3851 5.79492L8.79508 16.3749Z"
      fill="currentColor"
    />
  </svg>
);

export default CheckmarkIcon;
